import React from 'react';

export const CarouselItem = ({ isActive, currentIndex, children }) => {
    const carouselItemClassName = `carousel-item  ${isActive ? 'active' : ''}`;
    const carouselItemStyle = {
        transform: `translateX(-${currentIndex * 100}%)`,
        WebkitTransform: `translateX(-${currentIndex * 100}%)`,
        webkitTransform: `translateX(-${currentIndex * 100}%)`,
    };

    return (
        <div className={carouselItemClassName} style={carouselItemStyle} data-testid="carousel-item">
            {children}
        </div>
    );
};
